import React from "react";
import { motion } from "framer-motion";
import { useCountUp } from "../../hooks/useCountUp";
import { useInView } from "../../hooks/useInView";
import { EasyonReveal } from "./EasyonMotion";

const counterItems = [
    { value: 1280, prefix: "₹", suffix: "K", label: "Monthly Revenue Processed" },
    { value: 420, prefix: "", suffix: "", label: "Orders Closed This Month" },
    { value: 100, prefix: "", suffix: "%", label: "Inventory Accuracy" },
    { value: 100, prefix: "", suffix: "%", label: "GST Compliance Readiness" },
];

const CounterCard = ({ value, prefix, suffix, label, active }: { value: number; prefix: string; suffix: string; label: string; active: boolean }) => {
    const count = useCountUp(value, 1800, active);
    return (
        <motion.div className="eo-impact__stat" whileHover={{ y: -6, scale: 1.02 }}>
            <div className="eo-impact__num">
                {prefix}
                {count}
                {suffix}
            </div>
            <div className="eo-impact__lbl">{label}</div>
        </motion.div>
    );
};

export const EasyonBusinessImpactSection = () => {
    const { ref, isInView } = useInView(0.25);

    return (
        <section className="eo-impact" ref={ref}>
            <div className="eo-container">
                <EasyonReveal className="eo-impact__header">
                    <span className="eo-eyebrow">Revenue & Operations Counters</span>
                    <h2 className="eo-h2">Live Business Performance Snapshot</h2>
                    <p className="eo-lead">
                        Count-up counters track billing speed, order volume, inventory health, and compliance accuracy.
                    </p>
                </EasyonReveal>

                <div className="eo-impact__grid">
                    {counterItems.map((item) => (
                        <CounterCard key={item.label} {...item} active={isInView} />
                    ))}
                </div>
            </div>
        </section>
    );
};
